import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Radios from './Radios';
import Profiles from './Profiles';
import { close, loadingflas, open } from '../redux/popupSlice';
import Checkbox from './Checkbox';
import * as APIS from "../utils/service";
import { numFormat } from '../utils/utils';


export default function ProductTogetherPop(props) {

    const {
        setproductdetailflag = () => { },
        setproducttogetherflag = () => { },
        togetherinfoData = {},
        setcustomerdetailflag = () => { }
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { configdata } = useSelector(s => s.configReducer);

    const [checkvalues, setcheckvalues] = useState([]);
    const [nolistflag, setnolistflag] = useState(false);
    const [radio1, setradio1] = useState(0);
    const [errormsg, seterrormsg] = useState('');

    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return { names: x?.title, values: x?.idx }
    })
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return { names: x?.title, values: x?.idx }
    })

    //console.log("togetherinfoData", togetherinfoData);
    const [detailinfos, setdetailinfos] = useState([]);

    const [checkcommentArr, setcheckcommentArr] = useState([
        { numbers: '1.', comment: '상대 중개사가 요청을 수락하면 상대 중개사에게 의뢰인 연락처·특이사항 외 모든 정보가 전달 됩니다.' },
        { numbers: '2.', comment: '공동중개 요청·승낙 시 계약 유무와 별개로 상호간 공동중개 경험을 \'친절함·전문성·협조성\'을 점수로 평가 할 수 있으며 이는 타 중개사가 공동중개를 요청하기 전 점수를 확인할 수 있습니다. (공동중개 진행 여부에 영향을 미칠 수 있음.)' },
        { numbers: '3.', comment: '동일 부동산과의 공동중개가 여러번 진행되어도 평가는 최고점 1개만 적용 되며, 입력 된 평가는 특별한 사유 없이는 작성자 본인 외 수정·삭제가 불가능합니다.' },
        { numbers: '4.', comment: '평가 점수를 조작하기 위한 의도적인 작업이 적발되는 경우 내부 규정에 의거 공동중개 이용에 제한이 생길 수 있습니다.' },
        { numbers: '5.', comment: '악의적인 평가임이 확인되는 경우 별도 문의주시면 내부 규정에 맞는 서류 등을 안내 해드리며, 운영 규정에 따라 해당 평가는 삭제되며 악의적 작성자에게는 이용 제한 등의 불이익이 발생할 수 있습니다.' },
        { numbers: '6.', comment: '후기는 가입 시 입력된 ‘자격증 번호’ 등 ‘개인’에게 영구 저장되므로 이직·신규 개설·이전 개설을 진행하더라도 ‘자격증 번호’에 따른 점수가 노출됩니다.' },
        { numbers: '7.', comment: '따라서, 공동중개를 진행하시면 반드시 상도덕을 지키고 매너있는 협업을 진행해주시기 바랍니다.\n＊ 5건 미만의 경우 점수 등이 노출되지 않습니다' },
    ]);

    useEffect(() => {
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);

    useEffect(() => {
        if (togetherinfoData) {
            console.log("togetherinfoData", togetherinfoData);
            const { productinfo, sendtype } = togetherinfoData;
            console.log("🚀 ~ useEffect ~ productinfo:", productinfo);
            if (sendtype * 1 === 1) {
                let detailDatas = [];
                detailDatas.push({ viewernames: '고객번호', values:  productinfo?.idx});
                detailDatas.push({ viewernames: productinfo?.sell_type === '매매' ? '희망 매매가' : '희망 보증금', values: `${numFormat(productinfo?.price_all_min)}만원 ~ ${numFormat(productinfo?.price_all_max)}만원` });
                if (productinfo?.sell_type === '월세') {
                    detailDatas.push({ viewernames: '희망 월세', values: `${numFormat(productinfo?.price_month_min)}만원 ~ ${numFormat(productinfo?.price_month_max)}만원` });
                }
                detailDatas.push({ viewernames: '희망 매물종류', values: category_2_setting?.find(x => x?.values * 1 === productinfo?.category_2 * 1)?.names });
                detailDatas.push({ viewernames: '희망 층수', values: `${numFormat(productinfo?.item_floor_min)}층 ~ ${numFormat(productinfo?.item_floor_max)}층` });
                detailDatas.push({ viewernames: '희망 면적', values: `${numFormat(productinfo?.item_area_min)}㎡ ~ ${numFormat(productinfo?.item_area_max)}㎡` });
                detailDatas.push({ viewernames: '희망 연식', values: `${productinfo?.item_year_min}년 ~ ${productinfo?.item_year_max}년` });
                detailDatas.push({ viewernames: '입주시기', values: `${productinfo?.in_year} ${productinfo?.in_year_option1 ? '협의가능' : ''}  ${productinfo?.in_year_option2 ? '상관없음' : ''}` });

                setdetailinfos(detailDatas)
            } else {
                let detailDatas = [];
                detailDatas.push({ viewernames: '고객번호', values:  productinfo?.idx});
                detailDatas.push({ viewernames: '주소', values: `${productinfo?.sido} ${productinfo?.sigungu} ${productinfo?.dong}` });
                detailDatas.push({ viewernames: '매물종류', values: category_2_setting?.find(x => x?.values * 1 === productinfo?.category_2 * 1)?.names });
                if(productinfo?.category_1*1 === 1 || productinfo?.category_1*1 === 2){
                    detailDatas.push({viewernames: '해당층', values: String(productinfo?.building_floor).replace("층","")+'층'});
                    detailDatas.push({ viewernames: '전용면적', values: `${productinfo?.area_private}㎡ (약 ${((productinfo?.area_private * 1) / 3.3057).toFixed(2)}평)` });
                }
                if(productinfo?.category_1*1 === 3){
                    detailDatas.push({ viewernames: '토지면적', values: `${productinfo?.area_land}㎡ (약 ${((productinfo?.area_land * 1) / 3.3057).toFixed(2)}평)` });
                    detailDatas.push({ viewernames: '연면적', values: `${productinfo?.area_floor * 1}㎡ (약 ${((productinfo?.area_floor * 1) / 3.3057).toFixed(2)}평)` });
                    detailDatas.push({ viewernames: '지하총층', values: String(productinfo?.building_floor_under_all).replace("층","")+'층'});
                    detailDatas.push({ viewernames: '지상총층', values: String(productinfo?.building_floor_all).replace("층","")+'층'});
                }
                detailDatas.push({ viewernames: '방향기준/방향', values: `${productinfo?.item_direction_standard}/${productinfo?.item_direction}` });
                detailDatas.push({ viewernames: '건축물용도', values: productinfo?.item_usage });
                detailDatas.push({ viewernames: '건축물일자', values: `${productinfo?.item_date_type}/${productinfo?.item_date}` });
                detailDatas.push({ viewernames: '입주가능일', values: productinfo?.item_move_date + (productinfo?.item_move_type ? `, ${productinfo?.item_move_type}` : "") });
                setdetailinfos(detailDatas);
            }

        }

    }, [togetherinfoData]);

    return (
        <>
            <div className='ProductDetailArea'>
                <div>
                    <div className='ProductDetailAreaBG'
                    // onClick={() => {
                    //     setproductdetailflag(true);
                    //     setproducttogetherflag(false);
                    //     setcustomerdetailflag(true);
                    // }}
                    />

                    <div></div>
                    <div className="ProductSendDetailpop">
                        <div className="ProductpopTitle padding20" style={{ borderBottom: '1px solid #eee' }}>
                            <span>공동중개 요청</span>
                            <button
                                onClick={() => {
                                    setproductdetailflag(true);
                                    setproducttogetherflag(false);
                                    setcustomerdetailflag(true);
                                }}
                            >
                                <img src="./images/icons/x.svg" />
                            </button>
                        </div>
                        <div className="ProductSendInfos padding32" style={{ borderBottom: '4px solid #eee' }}>
                            {togetherinfoData?.togetherinfo?.mediation && <div style={{
                                marginBottom: 20,
                            }}>
                                <span style={{ color: 'red' }}>*</span> 이미 거절 된 이력이 있는 공동중개입니다. 재요청에도 다시 거절이 되는 경우 해당 매물(또는 고객)에게 다시 공동중개를 요청할 수 없으니 <b>반드시 상대방과 연락 후에 공동중개를 요청</b>하시기 바랍니다.
                            </div>}

                            <div className="fontsize16 bolds">{togetherinfoData?.sendtype * 1 === 1 ? "고객정보" : "매물정보"}</div>
                            <div className='margint20'>공동중개 요청 시 아래의 정보가 공유됩니다</div>
                            <div className='infos margint8'>
                                {detailinfos?.length > 0 && detailinfos?.map((x, i) => {
                                    if ([1, 2].includes(togetherinfoData?.productinfo?.category_1)) {
                                        if (x?.viewernames === '토지면적' || x?.viewernames === '연면적') {
                                            return;
                                        }
                                    }
                                    if ([3].includes(togetherinfoData?.productinfow?.category_1)) {
                                        if (x?.viewernames === '전용면적') {
                                            return;
                                        }
                                    }
                                    return (
                                        <div key={i}>
                                            <div style={{ width: 140 }}>{x?.viewernames}</div>
                                            <div>{x?.values}</div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="ProductSendInfos padding32" style={{ borderBottom: '4px solid #eee' }}>
                            <div className="fontsize16 bolds">공동중개 평가점수</div>
                            {togetherinfoData && <Profiles memberinfosData={togetherinfoData?.togetherinfo?.user} companyinfos={togetherinfoData?.togetherinfo?.compony} />}
                        </div>

                        <div className="ProductSendInfos padding32" >
                            <div className="fontsize16 bolds">확인사항</div>
                            <div className="bolds margint20">※ 공동중개 요청/수락 전 받드시 읽어주세요.</div>
                            <div className="checkComment">
                                {checkcommentArr?.length > 0 && checkcommentArr?.map((x, i) => {
                                    return (
                                        <div key={i}>
                                            <div>{x?.numbers}</div>
                                            <div>{x?.comment}</div>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className='margint20'>
                                <Checkbox
                                    linetype={'checkimg'}
                                    values={checkvalues}
                                    setvalues={(e) => {
                                        setcheckvalues(e);
                                        seterrormsg('');
                                    }}
                                    namevalue={[
                                        { names: '위 사항을 모두 확인 후 공동중개 요청 함', values: 0 },
                                    ]}
                                    fontweights={400}
                                    fontSizes={12}
                                    sizes={20}
                                />
                            </div>
                            {errormsg &&
                                <p className="input_error margint10" style={{ width: '100%', }}>
                                    <span></span>{errormsg}
                                </p>
                            }

                            <div className='margint20'>
                                <Button
                                    buttonTxt={'요청하기'}
                                    styles={{
                                    }}
                                    onPress={() => {
                                        if (checkvalues?.length === 0) {
                                            seterrormsg('확인사항의 확인여부를 선택해주세요.');
                                            return;
                                        }
                                        let sender = {};
                                        let targetproductName = '';
                                        if (togetherinfoData?.sendtype * 1 === 1) {
                                            //고객에서 요청
                                            sender = {
                                                type: togetherinfoData?.sendtype,
                                                target_idx: togetherinfoData?.togetherinfo?.u_idx,
                                                c_idx: togetherinfoData?.productinfo?.idx,
                                                i_idx: togetherinfoData?.togetherinfo?.idx,
                                            }
                                            targetproductName = '매물';

                                        } else {
                                            //매물에서 요청
                                            sender = {
                                                type: togetherinfoData?.sendtype,
                                                target_idx: togetherinfoData?.togetherinfo?.u_idx,
                                                c_idx: togetherinfoData?.togetherinfo?.idx,
                                                i_idx: togetherinfoData?.productinfo?.idx,
                                            }
                                            targetproductName = '고객';
                                        }
                                        console.log(sender);
                                        //return;
                                        let compony = togetherinfoData?.togetherinfo?.compony;
                                        let users = togetherinfoData?.togetherinfo?.user;
                                        let fullName = `${compony?.title} ${users?.name}  ${users?.rank}`;
                                        dispatch(loadingflas({ loading: true }));
                                        APIS.postData('/v1/mediation/application', sender).then(({ data }) => {
                                            if (data) {
                                                const PopComponents = () => {
                                                    return (
                                                        <div className='producttogetheralertArea'>
                                                            <div>공동중개 요청이 완료되었습니다.</div>
                                                            <div>
                                                                <b style={{ color: '#6164A5' }}>[{fullName}]</b>님이 요청을 수락하시면 매물 정보를 전송 받습니다.
                                                                단, 연락처 등 민감정보는 제공되지 않으며 <b style={{ color: '#6164A5' }}>{targetproductName}에 대한 소통은 반드시 {fullName}님과 진행</b>하시기 바랍니다.
                                                                상도에 어긋나는 비매너 행위는 평가점수 하락 및 서비스 이용에 제재가 될 수 있습니다.
                                                            </div>
                                                            <div>
                                                                공동중개 후기 작성은 계약이 체결되거나 공동중개가 종료된 이후 작성할 수 있습니다. (1회만 작성 가능)
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                                dispatch(
                                                    open({
                                                        component: <PopComponents />,
                                                        button: "닫기",
                                                        titleviewer: false,
                                                        alert: false,
                                                        onPress: () => {
                                                            setproductdetailflag(true);
                                                            setcustomerdetailflag(true);
                                                            setproducttogetherflag(false);
                                                            dispatch(close());
                                                        },
                                                    })
                                                );
                                            }
                                        }).catch(({ response }) => {
                                            const { data } = response;
                                            console.log(data);
                                            dispatch(
                                                open({
                                                    component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                                    title: '알림',
                                                    button: "확인",
                                                    titleviewer: true,
                                                    alert: false,
                                                    onPress: () => {
                                                        dispatch(close());
                                                    },
                                                })
                                            );
                                        }).finally(() => {
                                            dispatch(loadingflas({ loading: false }));
                                        });


                                    }}
                                />
                            </div>
                        </div>

                    </div>
                    <div></div>
                </div>
            </div>
        </>
    )
}